"use client";

import Image from "@/components/AppImage";
import Link from "@/components/AppLink";
import {
  getDashboardLoginUrl,
  getDashboardRegisterUrl,
} from "@/config/dashboardOrigin";
import { usePathname } from "@/hooks/navigation";
import { useEffect, useRef, useState } from "react";
import Select from "../common/Select";
import { navData } from "./navData";

const langSelector = [
  { id: 1, name: "EN" },
  { id: 2, name: "BN" },
  { id: 3, name: "ES" },
  { id: 4, name: "NL" },
];

const NavBar = () => {
  const [windowHeight, setWindowHeight] = useState(0);
  const menus = useRef<HTMLDivElement>(null);
  const path = usePathname();
  const hidenMenu = () => {
    menus.current!.classList.remove("show");
  };

  const navBarTop = () => {
    if (window !== undefined) {
      const height = window.scrollY;
      setWindowHeight(height);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", navBarTop);
    return () => {
      window.removeEventListener("scroll", navBarTop);
    };
  }, []);

  return (
    <header
      className={`header-section ${
        windowHeight > 50 && "animated fadeInDown header-fixed"
      } `}>
      <div className="overlay">
        <div className="container">
          <div className="row d-flex header-area">
            <nav className="navbar d-flex navbar-expand-lg navbar-dark">
              <Link className="navbar-brand" href="/" title="OracleMarket — Home">
                <Image
                  src="/img/oraclemark-logo.svg"
                  className="logo"
                  alt="OracleMarket"
                  width={180}
                  height={44}
                  priority
                />
              </Link>
              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarNavDropdown"
                aria-label="Toggle navigation">
                <i className="fas fa-bars"></i>
              </button>
              <div
                className="collapse navbar-collapse justify-content-end"
                id="navbarNavDropdown"
                ref={menus}>
                <ul className="navbar-nav">
                  {navData.map(
                    ({
                      itm,
                      url,
                      id,
                      dropdown,
                      dropdown_itms,
                      mega_menu,
                      nav_variant,
                      dropdown_kicker,
                      dropdown_title,
                    }) => {
                      const isServicesNav = nav_variant === "freelancers";
                      const isPanelDropdown =
                        nav_variant === "freelancers" ||
                        nav_variant === "about" ||
                        nav_variant === "help";
                      const dropdownVariantClass = isPanelDropdown
                        ? " nav-item--freelancers-dropdown"
                        : "";
                      const isActive = isServicesNav
                        ? path === "/" || path.startsWith("/index-")
                        : dropdown_itms &&
                          dropdown_itms.some(({ url: u }) => path == u);
                      return !dropdown ? (
                        <li className="nav-item" key={id}>
                          <Link
                            className={`nav-link ${path == url && "active"}`}
                            href={url}
                            onClick={hidenMenu}>
                            {itm}
                          </Link>
                        </li>
                      ) : (
                        <li
                          className={`nav-item dropdown${dropdownVariantClass}`}
                          key={id}>
                          <Link
                            className={`nav-link dropdown-toggle ${
                              isActive && "active"
                            }`}
                            href="/"
                            role="button"
                            data-bs-toggle="dropdown">
                            {itm}
                          </Link>
                          {isPanelDropdown ? (
                            <div className="dropdown-menu dropdown-menu-freelancers">
                              <div className="freelancers-dropdown-panel">
                                <div className="freelancers-dropdown-header">
                                  <span className="freelancers-dropdown-kicker">
                                    {dropdown_kicker || "Our services"}
                                  </span>
                                  <p className="freelancers-dropdown-title">
                                    {dropdown_title ||
                                      "Explore what OracleMarket can do for you"}
                                  </p>
                                </div>
                                <ul className="freelancers-dropdown-grid">
                                  {dropdown_itms?.map(
                                    ({ id: itemId, dp_itm, url: itemUrl, icon }) => (
                                      <li key={itemId}>
                                        <Link
                                          className={`freelancers-dropdown-card ${
                                            path == itemUrl && "active"
                                          }`}
                                          href={itemUrl}
                                          onClick={hidenMenu}>
                                          {icon ? (
                                            <span
                                              className="freelancers-dropdown-card__icon"
                                              aria-hidden>
                                              <i className={icon} />
                                            </span>
                                          ) : null}
                                          <span className="freelancers-dropdown-card__label">
                                            {dp_itm}
                                          </span>
                                        </Link>
                                      </li>
                                    ),
                                  )}
                                </ul>
                              </div>
                            </div>
                          ) : mega_menu ? (
                            <div className="dropdown-menu mega-menu">
                              <ul className="dropdown">
                                {dropdown_itms?.map(
                                  ({ id: mid, dp_itm, url: megaUrl }) => (
                                    <li key={mid}>
                                      <Link
                                        className={`nav-item ${
                                          path == megaUrl && "active"
                                        }`}
                                        href={megaUrl}
                                        onClick={hidenMenu}>
                                        {dp_itm}
                                      </Link>
                                    </li>
                                  ),
                                )}
                              </ul>
                            </div>
                          ) : (
                            <ul className="dropdown-menu">
                              {dropdown_itms?.map(
                                ({ id: did, dp_itm, url: dropUrl }) => (
                                  <li key={did}>
                                    <Link
                                      className={`nav-item ${
                                        path == dropUrl && "active"
                                      }`}
                                      href={dropUrl}
                                      onClick={hidenMenu}>
                                      {dp_itm}
                                    </Link>
                                  </li>
                                ),
                              )}
                            </ul>
                          )}
                        </li>
                      );
                    }
                  )}
                </ul>
                <div className="right-area header-action d-flex align-items-center">
                  <div className="lang d-flex align-items-center d-lg-none d-xxl-flex">
                    <Image
                      src="/img/lang.svg"
                      alt=""
                      width={24}
                      height={24}
                    />
                    {/* Select */}
                    <Select data={langSelector} />
                  </div>
                  <Link href={getDashboardLoginUrl()} className="cmn-btn login">
                    Login
                  </Link>
                  <Link
                    href={getDashboardRegisterUrl()}
                    className="cmn-btn d-lg-none d-xxl-block">
                    Sign up
                  </Link>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default NavBar;
